import { render, staticRenderFns } from "./BrandForm.vue?vue&type=template&id=57bd483a&"
import script from "./BrandForm.vue?vue&type=script&lang=js&"
export * from "./BrandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports